export function isEurope(shopId) {
  return shopId === "alpine-water-gmbh";
}
